import { atom } from 'jotai';
import { Me } from '@/functions/types/me';

export const meAtom = atom<Me>({} as Me);

meAtom.debugLabel = 'meAtom';
